<template>
  <div class="student-mange">
    <div class="toolbar">
      <div>自定义素材包：</div>
      <div class="check-all" v-if="diyRes !== null && diyRes.enabled">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <el-button
          type="text"
          class="unlock-photograph"
          @click="handleUnlockPhotograph"
          >批量解锁 (剩余：{{ diyRes.amount }})</el-button
        >
      </div>
      <div v-else>不支持</div>
    </div>
    <div class="toolbar">
      <div>全班视频观看时长：</div>
      <span class="theme-text-link" @click="handleGroupWatchTotals">查看</span>
      <span class="theme-text-link download-csv-btn" @click="handleDownloadCsv">下载 csv</span>
    </div>

    <div>
      <el-checkbox-group
        v-model="checkeds"
        @change="handleCheckedChange"
        class="stu-list"
      >
        <div
          class="stu-items"
          v-for="(item, index) in studentData.list"
          :key="index"
        >
          <div class="it-top">
            <el-checkbox :label="item.id" v-if="(diyRes && diyRes.enabled) && item.ticket_status === 0">{{
              ``
            }}</el-checkbox>
            <div
              class="upload-cancel"
              @mouseenter="item.photoState = true"
              @mouseleave="item.photoState = false"
            >
              <svg-icon
                v-if="item.ticket_status !== 0"
                icon-class="photo-icon"
                class="svg-icon-class"
              />
              <div class="edit-box" v-if="item.photoState">
                <div class="label theme-text-link" @click="handleCheckPhotp(item)">
                  查看素材
                </div>
                <div class="label theme-text-link" @click="handleCancelTicket(item)">
                  撤销权限
                </div>
              </div>
            </div>
          </div>
          <div class="card-header">
            <span class="nickname">{{ item.nickname }}</span>
            <span class="username"">@{{ item.name }}</span>
          </div>
          <div class="entry">
            <div class="entry-label">课程进度</div>
            <div class="content">{{Math.round((item.lessons_num / item.total_lesson_num) * 100) }}%</div>
          </div>
          <div class="entry">
            <div class="entry-label">最近学习</div>
            <div class="content">{{ item.latest_lesson_name || "无" }}</div>
          </div>
          <div class="entry">
            <div class="entry-label">解锁日志</div>
            <div class="content-button theme-text-link" @click="handleUnlockLessonLog(item)">查看详情</div>
          </div>
          <div class="entry">
            <div class="entry-label">视频观看时长</div>
            <div class="content-button theme-text-link" @click="handleWatchTotal(item)">查看详情</div>
          </div>
          <div class="entry">
            <div class="entry-label">游戏控制</div>
            <div class="content-button theme-text-link" @click="studentListDiaClick(item.id)">打开控制面板</div>
          </div>
        </div>
      </el-checkbox-group>
    </div>
    <div class="block" style="text-align: center; margin-top: 30px">
      <el-pagination
        background
        layout="prev, pager, next, total, jumper"
        :page-size="8"
        v-if="studentData.list !== undefined && studentData.list.length !== 0"
        :total="studentData.count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <el-dialog
      class="student-list"
      title="游戏列表"
      :center="true"
      :visible.sync="studentListDialog"
      width="57%"
      z-index="500"
    >
      <div>
        <el-row :gutter="45">
          <el-col
            v-for="item in gameData"
            :lg="{ span: '4-8' }"
            :span="6"
            :key="item.rec_id"
            class="list-le-col"
          >
            <div @click="checkClick(item.rec_id)">
              <el-card class="box-card">
                <div>
                  <el-avatar
                    size="medium"
                    class="avatar-box"
                    :src="item.game_img"
                  ></el-avatar>
                </div>
                <p class="name">{{ item.game_name }}</p>
                <span
                  v-if="studentLockGames.indexOf(item.rec_id) >= 0"
                  class="pitch-box"
                  :class="
                    studentLockGames.indexOf(item.rec_id) >= 0
                      ? 'checked'
                      : 'unchecked'
                  "
                >
                  <i class="el-icon-success success"></i>
                </span>
                <span v-else class="pitch-box1"> </span>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog
      class="student-list"
      :title="stuTitleUnlockTitle"
      :center="true"
      :visible.sync="stuLessonUnlockState"
      width="57%"
      z-index="500"
    >
      <div>
        <div class="column-2">
          <div class="les-name">&nbsp;&nbsp;&nbsp;&nbsp;课时名</div>
          <div class="let-time">解锁时间</div>
          <div class="let-time">上课开始时间</div>
          <div class="let-time">上课结束时间&nbsp;&nbsp;&nbsp;&nbsp;</div>
        </div>
        <div class="info-list-2">
          <div class="item-info-2" v-for="item in lessonUnlockData" :key="item">
            <div class="les-name">{{ item.lesson_name }}</div>
            <div class="let-time">{{ item.create_time }}</div>
            <div class="let-time">{{ item.start_time }}</div>
            <div class="let-time">{{ item.end_time }}</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      class="student-list"
      :title="stuTitleWatchTitle"
      :center="true"
      :visible.sync="stuWatchTotalState"
      width="57%"
      z-index="500"
    >
      <div class="watch-total-wrap">
        <div class="column-2">
          <div class="les-name">&nbsp;&nbsp;&nbsp;&nbsp;课时名</div>
          <div class="let-time">累计观看&nbsp;&nbsp;&nbsp;&nbsp;</div>
        </div>
        <div class="info-list-2">
          <div
            class="item-info-2"
            v-for="item in lessonWatchData"
            :key="item.lesson_id"
          >
            <div class="les-name">{{ item.lesson_name }}</div>
            <div class="let-time">{{ formatWatchSeconds(item.total_watch_seconds) }}</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      class="student-list"
      :title="groupWatchTitle"
      :center="true"
      :visible.sync="groupWatchTotalState"
      width="70%"
      z-index="500"
    >
      <div class="group-watch-total-wrap">
        <div class="action-bar">
          <span class="theme-text-link" @click="handleDownloadCsv">下载 csv</span>
          <div class="filter-controls">
            按时长高亮：
            <el-dropdown trigger="click" @command="handleDurationChange">
              <span class="duration-trigger">{{ formatDurationLabel(durationThreshold) }}</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="durationThreshold === 60" :command="60">1分钟</el-dropdown-item>
                <el-dropdown-item :disabled="durationThreshold === 120" :command="120">2分钟</el-dropdown-item>
                <el-dropdown-item :disabled="durationThreshold === 180" :command="180">3分钟</el-dropdown-item>
                <el-dropdown-item :disabled="durationThreshold === 300" :command="300">5分钟</el-dropdown-item>
                <el-dropdown-item :disabled="durationThreshold === 600" :command="600">10分钟</el-dropdown-item>
                <el-dropdown-item :disabled="durationThreshold === 1200" :command="1200">20分钟</el-dropdown-item>
                <el-dropdown-item :disabled="durationThreshold === 1800" :command="1800">30分钟</el-dropdown-item>
                <el-dropdown-item :disabled="durationThreshold === 3600" :command="3600">1小时</el-dropdown-item>
                <el-dropdown-item divided :command="'custom'">自定义...</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-form inline class="custom-filter-form" v-if="durationThreshold === -1" @submit.native.prevent="submitCustomForm">
              <el-form-item>
                <el-input-number ref="customInput" v-model="customDuration" :min="0" :step="60" size="small" style="width: 120px;"></el-input-number>
              </el-form-item>
              <el-form-item>
                <el-button class="theme-text-link" type="text" size="mini" @click="submitCustomForm">应用</el-button>
              </el-form-item>
            </el-form>
            <span class="theme-text-link" @click="clearDurationFilter" v-if="durationThreshold > 0">清除</span>
          </div>
        </div>
        <el-table :data="groupStudents" border stripe max-height="500">
          <el-table-column prop="student_name" label="学生" min-width="150"></el-table-column>
          <el-table-column v-for="lesson in groupWatchTotalData" :key="lesson.lesson_name" :label="lesson.lesson_name" min-width="150">
            <template slot-scope="scope">
              <span :class="{ 'duration-highlight': durationThreshold > 0 && getStudentSeconds(lesson, scope.row.student_id) >= durationThreshold }">
                {{ formatWatchSeconds(getStudentSeconds(lesson, scope.row.student_id)) }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <PhotoShow ref="PhotoShow"></PhotoShow>
  </div>
</template>

<script>
import Api from "@/models/Home/Api";
import Student from "@/models/Home/Student";
import { MsgTip } from "../common/MsgTip";
import PhotoShow from "./PhotoShow.vue";

export default {
  name: "StudentMange",
  components: {
    PhotoShow,
  },
  data() {
    return {
      page: 1,
      studentListDialog: false,
      stuLessonUnlockState: false,
      studentData: [],
      gameData: [],
      studentLockGames: [],
      lessonUnlockData: [],
      stuTitleUnlockTitle: "",
      stuWatchTotalState: false,
      stuTitleWatchTitle: "",
      lessonWatchData: [],

      diyRes: null, //状态
      checkAll: false,
      isIndeterminate: false,
      checkeds: [],

      groupWatchTotalState: false,
      groupWatchTitle: "",
      groupWatchTotalData: [],
      groupStudents: [],
      durationThreshold: 0,
      customDuration: 60,
      customEnterPressed: false,
    };
  },
  created() {
    this.getStudentInfo();
    this.getGameInfo();
    this.getCartoonAmount();
  },
  computed: {
    GroupData() {
      //监听store的数据
      return this.$store.getters.getGroupData;
    },
    CourseData() {
      //监听store的数据
      return this.$store.getters.getCourseData;
    },
  },
  watch: {
    GroupData() {
      console.log(this.$store.getters.getCourseData);
      this.getStudentInfo();
    },
    CourseData() {
      this.getCartoonAmount();
    },
    durationThreshold(val) {
      if (val === -1) {
        this.$nextTick(() => {
          const input = this.$refs.customInput;
          if (input && input.focus) {
            input.focus();
          }
        });
      }
    },
  },
  methods: {
    //学生管理列表
    getStudentInfo() {
      let param = {
        group_id: this.$store.getters.getGroupData.group_id,
        page: this.page,
        limit: 8,
      };
      Student.getStudentList(param, ({ type, list }) => {
        if (type === 200) {
          list.list.forEach((item) => {
            if (item.latest_lesson_name.indexOf("<br>") > -1) {
              item.latest_lesson_name = item.latest_lesson_name.replace(
                "<br>",
                "-"
              );
            }
            item.photoState = false;
          });
          this.studentData = list;

          console.log(this.studentData);
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getStudentInfo();
    },
    getGameInfo() {
      Api.fetchData(
        { params: {} },
        "/bureau/v1.2/listGames",
        ({ type, list }) => {
          this.gameData = list;
        }
      );
    },
    /**解锁课程日志*/
    handleUnlockLessonLog(item) {
      this.stuTitleUnlockTitle = item.nickname + "的解锁课程日志";
      this.stuLessonUnlockState = true;
      let param = {
        group_id: this.$store.getters.getGroupData.group_id,
        student_id: item.id,
      };
      Student.stuLessonUnlock(param, ({ type, list }) => {
        if (type === 200) {
          this.lessonUnlockData = list;
        }
      });
    },
    /**课时观看累计（老师查看学生班课各课时观看时长）*/
    handleWatchTotal(item) {
      this.stuTitleWatchTitle = item.nickname + "的课时观看累计";
      this.stuWatchTotalState = true;
      this.lessonWatchData = [];
      let param = {
        student_id: item.id,
        group_id: this.$store.getters.getGroupData.group_id,
      };
      Api.fetchData(
        param,
        "/bureau/v1.2/studentLessonWatchTotals",
        ({ type, list }) => {
          if (type === 200) {
            this.lessonWatchData = list || [];
          }
        }
      );
    },
    /**秒数格式化为 HH:MM:SS*/
    formatWatchSeconds(sec) {
      sec = Number(sec) || 0;
      const h = Math.floor(sec / 3600);
      const m = Math.floor((sec % 3600) / 60);
      const s = Math.floor(sec % 60);
      const pad = (n) => (n < 10 ? "0" + n : "" + n);
      return pad(h) + ":" + pad(m) + ":" + pad(s);
    },
    /**点击角色小游戏*/
    studentListDiaClick(studentId) {
      this.studentListDialog = true;
      this.theStudent = studentId;
      this.getLockGames(studentId);
    },
    getLockGames(id) {
      Api.fetchData(
        {
          student_id: id,
        },
        "/bureau/v1.2/getLockGamesByStudent",
        ({ type, list }) => {
          this.studentLockGames = list;
        }
      );
    },
    //选中状态
    checkClick(game_id) {
      var index = this.studentLockGames.indexOf(game_id),
        mes = index >= 0 ? "上锁" : "开锁",
        is_lock = index >= 0 ? 0 : 1;
      this.$Dialog
        .confirm({
          message: '<span style="font-size: 16px">确定' + mes + "吗？</span>",
          confirmButtonColor: "#FF8D15",
        })
        .then(() => {
          Api.fetchData(
            {
              students: this.theStudent,
              games: game_id,
              is_lock: is_lock,
            },
            "/bureau/v1.2/lockGamesByStudent",
            () => {
              if (is_lock === 0) {
                this.studentLockGames.splice(index, 1);
                this.$message({
                  message: "上锁成功",
                  type: "success",
                  iconClass: "iconClass",
                });
              } else {
                this.studentLockGames.push(game_id);
                this.$message({
                  message: "开锁成功",
                  type: "success",
                  iconClass: "iconClass",
                });
              }
            }
          );
        });
    },
    /**全选按钮 */
    handleCheckAllChange(val) {
      let selectData = [];
      this.studentData.list.forEach((it) => {
        if (it.ticket_id === 0) {
          selectData = [...selectData, it.id];
        }
      });
      console.log(selectData);
      this.checkeds = val ? selectData : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.studentData.list.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.studentData.list.length;
    },
    /**查询是否可以解锁 */
    getCartoonAmount() {
      Student.getCartoonAmount(
        { course_id: this.$store.getters.getCourseData[0].id },
        ({ type, list }) => {
          if (type === 200) {
            this.diyRes = list;
          }
        }
      );
    },
    /**批量解锁素材包 */
    handleUnlockPhotograph() {
      if (this.diyRes === null || !this.diyRes.enabled) {
        MsgTip({ type: "error", message: "该班级课程下不可以解锁素材包" });
        return;
      }
      if (this.checkeds.length === 0) {
        MsgTip({ type: "error", message: "请选择一名学生解锁素材包" });
        return;
      }

      const params = {
        course_id: this.$store.getters.getCourseData[0].id,
        student_id: this.checkeds,
      };
      this.$Dialog
        .confirm({
          message: `<span style="font-size: 16px">确定解锁素材包吗？</span>`,
          confirmButtonColor: "#FF8D15",
        })
        .then(() => {
          Student.assignTicket(params, ({ type, list }) => {
            console.log(type, list);
            if (type === 200) {
              MsgTip({ type: "success", message: "解锁成功" });
              this.getStudentInfo();
              this.getCartoonAmount();
            }
          });
        });
    },
    /**查看图片 */
    handleCheckPhotp(item) {
      this.$refs.PhotoShow.ticket_id = item.ticket_id;
      this.$refs.PhotoShow.dialogState = true;
    },
    /**撤销权限 */
    handleCancelTicket(item) {
      this.$Dialog
        .confirm({
          message: `<span style="font-size: 16px">确定撤销拍照吗？</span>`,
          confirmButtonColor: "#FF8D15",
        })
        .then(() => {
          const params = {
            ticket_id: item.ticket_id,
          };
          Student.cancelTicket(params, ({ type, list }) => {
            console.log(type, list);
            if (type === 200) {
              MsgTip({ type: "success", message: "撤销成功" });
              this.getStudentInfo();
              this.getCartoonAmount();
            }
          });
        });
    },

    /**获取全班视频时长数据（共享方法）*/
    fetchGroupWatchData() {
      return new Promise((resolve) => {
        let param = {
          group_id: this.$store.getters.getGroupData.group_id,
        };
        Api.fetchData(
          param,
          "/bureau/v1.2/groupLessonWatchTotals",
          ({ type, list }) => {
            if (type !== 200) {
              resolve({ data: [], students: [] });
              return;
            }
            const data = list || [];
            const studentMap = new Map();
            for (const lesson of data) {
              if (lesson.students) {
                for (const s of lesson.students) {
                  if (!studentMap.has(s.student_id)) {
                    studentMap.set(s.student_id, {
                      student_id: s.student_id,
                      student_name: s.student_name || "",
                    });
                  }
                }
              }
            }
            const students = Array.from(studentMap.values()).sort((a, b) => a.student_id - b.student_id);
            resolve({ data, students });
          }
        );
      });
    },

    /**班级课时观看累计 - 查看全班视频时长*/
    handleGroupWatchTotals() {
      this.groupWatchTitle = "全班视频观看时长";
      this.groupWatchTotalState = true;
      this.groupWatchTotalData = [];
      this.groupStudents = [];
      this.fetchGroupWatchData().then(({ data, students }) => {
        this.groupWatchTotalData = data;
        this.groupStudents = students;
      });
    },

    /**下载 CSV - 获取数据并直接保存*/
    handleDownloadCsv() {
      this.fetchGroupWatchData().then(({ data, students }) => {
        if (!data.length) {
          MsgTip({ type: "warning", message: "暂无数据可导出" });
          return;
        }
        this.doExportCsv(data, students);
      });
    },

    /**执行 CSV 生成与下载*/
    doExportCsv(data, students) {
      const formatDuration = (seconds) => {
        seconds = Math.floor(seconds);
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0");
      };
      const headers = ["学生", ...data.map((lesson) => lesson.lesson_name)];
      const rows = students.map((s) => {
        return [
          s.student_name || ("学生" + s.student_id),
          ...data.map((lesson) => {
            const studentData = lesson.students ? lesson.students.find((st) => st.student_id === s.student_id) : null;
            return formatDuration(studentData ? studentData.total_watch_seconds : 0);
          }),
        ];
      });
      const quoteCell = (val) => {
        val = String(val);
        if (val.includes(",") || val.includes('"') || val.includes("\n") || /\s/.test(val)) {
          return '"' + val.replace(/"/g, '""') + '"';
        }
        return val;
      };
      let csvContent = "\uFEFF" + headers.map(quoteCell).join(",") + "\n";
      for (const row of rows) {
        csvContent += row.map(quoteCell).join(",") + "\n";
      }
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      const groupName = this.$store.getters.getGroupData && this.$store.getters.getGroupData.group_name ? this.$store.getters.getGroupData.group_name : "班级";
      const courseName = this.$store.getters.getCourseData && this.$store.getters.getCourseData[0] && this.$store.getters.getCourseData[0].title ? this.$store.getters.getCourseData[0].title : "课程";
      link.download = `${groupName}_${courseName}_视频观看时长.csv`;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    /**根据学生ID从课时数据中获取观看秒数*/
    getStudentSeconds(lesson, studentId) {
      if (!lesson.students) return 0;
      const s = lesson.students.find((st) => st.student_id === studentId);
      return s ? s.total_watch_seconds : 0;
    },

    /**清除时长筛选*/
    clearDurationFilter() {
      this.durationThreshold = 0;
      this.customDuration = 60;
    },

    /**处理下拉选择*/
    handleDurationChange(command) {
      if (command === 'custom') {
        this.durationThreshold = -1;
      } else {
        this.durationThreshold = command;
      }
    },

    submitCustomForm() {
      if (this.durationThreshold === -1) {
        this.durationThreshold = this.customDuration;
      }
    },

    /**格式化时长标签*/
    formatDurationLabel(sec) {
      sec = Number(sec) || 0;
      if (sec === 0) return "无";
      if (sec === -1) return "自定义...";
      const h = Math.floor(sec / 3600);
      const m = Math.floor((sec % 3600) / 60);
      const s = sec % 60;
      let parts = [];
      if (h > 0) parts.push(h + "小时");
      if (m > 0) parts.push(m + "分钟");
      if (s > 0) parts.push(s + "秒");
      return parts.join(" ") + "及以上";
    },
  },
};
</script>

<style lang="less" scoped>
.student-mange {
  width: calc(100% - 40px);
  margin: 12px auto;
  height: calc(99.7vh - 175px);
  overflow-y: scroll;
  border-radius: 10px;
}
.stu-list {
  padding: 32px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-row-gap: 10px;
  gap: 32px;
}

.stu-items {
  border-radius: 16px;
  background: #ffffff;
  color: #666;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  font-size: 14px;

  .it-top {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    padding: 8px 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .upload-cancel {
      margin-left: auto;
      position: relative;
    }
    .svg-icon-class {
      width: 24px;
      height: 24px;
      font-weight: bold;
      cursor: pointer;
      &:hover {
        color: #ff8d0d;
      }
    }
    .edit-box {
      position: absolute;
      width: 100px;
      height: 80px;
      z-index: 1;
      color: #ffffff;
      box-shadow: 0px 2px 10px #666666;
      background: #ffffff;
      right: -10px;
      border-radius: 10px;
      .label {
        height: 24px;
        padding: 8px 10px;
        color: #666666;
        font-size: 18px;
        &:hover {
          color: #ff8d0d;
          cursor: pointer;
        }
      }
    }
  }

  .card-header{
    display: flex;
    align-items: baseline;
    width: 100%;
    box-sizing: border-box;
    padding: 0 24px;
    margin: 16px 0;
    font-size: 15px;

    .nickname{
        font-weight: 700;
        font-size: 1.6em;
        color: #222;
    }

    .username{
        color: #888;
        margin-left: 6px;
    }
  }

  .entry{
    display: flex;
    width: 100%;
    padding: 0 24px;
    margin: 4px 0;
    align-items: baseline;
    font-size: 15px;
    box-sizing: border-box;
    gap: 8px;

    >.entry-label{
        width: 35%;
    }

    .content{
        flex: 1 1 auto;
        padding: 4px 16px;
        font-weight: 600;
    }

    .content-button{
        cursor: pointer;
        user-select: none;
        border-radius: 12px;
        padding: 4px 16px;
        color: #ff8d0d;
        &:hover {
          text-decoration: underline;
        }
    }
  }
}


.user-name-phone {
  width: calc(100% - 72px);
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.label {
  color: #666666;
  font-size: 24px;
}

.text {
  color: #333333;
  font-size: 24px;
  font-weight: 500;
}

.name {
  flex: 1;
  text-align: center;
}

.phone {
  text-align: center;
  flex: 1;
}

.unlock-lesson-log {
  width: calc(100% - 72px);
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.btn {
  flex: 1 1 96px;
  white-space: nowrap;
  background: #ff8d0d;
  height: 44px;
  border-radius: 10px;
  text-align: center;
  line-height: 44px;
  font-size: 20px;
  color: #ffffff;
  cursor: pointer;
}

.column-1 {
  background: #ff8d0d;
  border-radius: 8px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
}

.info-list {
  height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
  margin: 12px 0;
}
.item-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  border-bottom: 1px solid #dddddd;
  //background: pink;
}
.unlock-btn {
  margin: 0 auto;
  color: #ffffff;
  cursor: pointer;
  width: 100px;
  padding: 8px 0;
  text-align: center;
  background: #ff8d15;
  border-radius: 4px;
  font-weight: bold;
}

.center {
  text-align: center;
}

.text-font-size {
  font-size: 14px;
  color: #606266;
}

.subject-name {
  width: 240px;
}

.group-name {
  width: 240px;
}

.lesson-name {
  width: 240px;
}

.list-le-col {
  margin-bottom: 30px;
}
.box-card {
  text-align: center;
  position: relative;
  cursor: pointer;
}
.avatar-box {
  width: 100px;
  height: 100px;
  background-color: #fff;
}

.name {
  font-size: 24px;
  color: #898989;
}

.pitch-box {
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 16px;
  border: 1px solid #ddd;

  .success {
    font-size: 24px;
  }
}

.pitch-box1 {
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 16px;
  border: 1px solid #ddd;
  width: 18px;
  height: 18px;

  .success {
    font-size: 24px;
  }
}

.checked {
  border: none;
  color: #ff8d0d;
}

.unchecked {
  i {
    color: #fff;
  }
}

.disable {
  border: none;

  i {
    color: #fff;
  }
}

.in-use {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
}

.column-2 {
  background: #ff8d0d;
  border-radius: 10px;
  display: flex;
  align-items: center;

  height: 40px;
  color: #ffffff;
  font-weight: bold;
  .les-name {
    width: 320px;
  }
  .let-time {
    width: 200px;
    margin: 0 20px;
  }
}
.info-list-2 {
  height: 500px;
  overflow-y: scroll;
}
.item-info-2 {
  display: flex;
  border-bottom: 1px solid #ddd;
  height: 40px;
  line-height: 40px;
}
.les-name {
  width: 320px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.let-time {
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 20px;
}

/* 课时观看累计弹窗：两列布局（课时名占满 + 累计观看固定宽） */
.watch-total-wrap {
  .les-name {
    width: auto;
    flex: 1;
  }
  .let-time {
    width: 240px;
    text-align: right;
  }
}

/* 全班视频时长弹窗 */
.group-watch-total-wrap {
  .action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-size: 14px;

    .export-btn {
      color: #ff8d0d;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }

    .filter-controls {
      display: flex;
      align-items: center;
      gap: 8px;

      .duration-trigger {
        color: #ff8d0d;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .el-table {
    font-size: 13px;
  }
}

/* 时长达标高亮 */
.duration-highlight {
  color: #52c41a;
  font-weight: 600;
}

/* 主题色文字链接 */
.theme-text-link {
  color: #ff8d0d;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.download-csv-btn {
  margin-left: 16px;
}

.custom-filter-form {
  display: inline-flex;
  align-items: center;
  .el-form-item {
    margin-bottom: 0;
    margin-right: 8px;
  }
}

.toolbar{
  margin: 8px 32px 0;
  display: flex;
  font-size: 14px;
  align-items: baseline;
}

.check-all {
  .unlock-photograph {
    color: #666666;
    margin-left: 32px;
    &:hover {
      color: #ff8d0d;
    }
  }
}

/deep/.el-message .el-icon-error {
  font-size: 12px !important;
}
/deep/ .el-progress__text {
  font-size: 40px !important;
  font-weight: bold;
}

/deep/ .el-progress-circle {
  width: 140px !important;
  height: 140px !important;
}

/deep/ .el-pagination.is-background .btn-next,
/deep/ .el-pagination.is-background .btn-prev,
/deep/ .el-pagination.is-background .el-pager li {
  background-color: #ffffff;
  border: 1px solid #e3e3e3;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ff8d0d;
  color: #fff;
}

/deep/ .el-pagination.is-background .el-pager li.active {
  color: #fff;
  cursor: default;
}

/deep/ .el-pagination.is-background .el-pager li:hover {
  color: #ff8d0d;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #ff8d0d;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: #ff8d0d;
  color: #fff;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ff8d0d;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ff8d0d;
  border-color: #ff8d0d;
}
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ff8d0d;
  border-color: #ff8d0d;
}
</style>
